import { Component, AfterViewChecked, OnDestroy, OnInit } from '@angular/core';

import { ActivatedRoute } from '@angular/router';

import { Subscription } from 'rxjs';

import { GUIDE_TABS } from './guide-pages';

@Component({
  selector: 'guide',
  templateUrl: './guide.component.html',
  styleUrls: ['./guide.component.scss']
})
export class GuideComponent implements AfterViewChecked, OnDestroy, OnInit {
  navbarOpen = false;
  selectedArticle = null;
  selectedSubArticle = null;
  activeTabLabel = null;
  fragment = null;
  overviewIllustration = 'room';

  // Each display mode has a horizontal and a vertical rendering of the same
  // screen.  They are different shapes, so they are separate illustrations
  // swapped by the 900px breakpoint rather than sources on one illustration.
  private static readonly MAIN_SCREEN_IMAGES = {
    room: 'dash-screen',
    dashboard: 'dashboard-screen',
    countdown: 'countdown-screen',
    scheduleDashboard: 'schedule-dashboard-screen',
    whatsOn: 'whatson-screen'
  };

  // Same artwork at every breakpoint, just different resolutions, so this stays
  // a single illustration with per-breakpoint sources.
  readonly brandingSources = [
    { media: '(max-width: 600px)', src: '/assets/images/branding-screenshot-wide_small.png' },
    { media: '(max-width: 1200px) and (min-resolution: 192dpi)', src: '/assets/images/branding-screenshot-wide_2x.png' },
    { media: '(max-width: 1200px)', src: '/assets/images/branding-screenshot-wide.png' }
  ];

  mainScreenImage(orientation: string, extension: string): string {
    const name = GuideComponent.MAIN_SCREEN_IMAGES[this.overviewIllustration]
      || GuideComponent.MAIN_SCREEN_IMAGES.room;
    return '/assets/images/' + name + '-' + orientation + '.' + extension;
  }

  // Resolved here rather than in the template so the GuideEntry union is narrowed
  // where TypeScript actually checks it.
  navTabs = GUIDE_TABS.map(tab => ({
    navLabel: tab.navLabel,
    article: tab.article,
    link: tab.kind === 'link' ? tab.routerLink : '/guide/' + tab.slug
  }));

  private subscriptions = new Subscription();

  constructor(
    private route: ActivatedRoute
  ) {
  }


  toggleNavbar() {
    this.navbarOpen = !this.navbarOpen;
  }

  closeNavbar() {
    this.navbarOpen = false;
  }

  toggleOverviewIllustration(displayType) {
    if(['room', 'countdown', 'dashboard', 'scheduleDashboard', 'whatsOn'].includes(displayType)) {
      this.overviewIllustration = displayType;
    }
  }

  ngAfterViewChecked(): void {
    if (this.fragment) {
      const fragmentElement = typeof document !== 'undefined' ? document.getElementById(this.fragment) : null;
      if (fragmentElement && typeof window !== 'undefined') {
        let yOffset = 0;

        const topBarElement = document.getElementById('topBar');
        if (topBarElement) {
          yOffset = topBarElement.getBoundingClientRect().top + topBarElement.getBoundingClientRect().height + 24;
        }

        const y = fragmentElement.getBoundingClientRect().top + window.pageYOffset - yOffset;
        window.scrollTo({top: y});
      }
      this.fragment = null;
    }

  }

  ngOnInit() {
    // Each guide page is its own route, so the article being shown comes from route
    // data. Subscribing rather than reading the snapshot keeps this correct if the
    // component is ever reused in place instead of being recreated per navigation.
    this.subscriptions.add(this.route.data.subscribe(data => {
      this.selectedArticle = data.article;
      this.selectedSubArticle = data.subArticle;
      this.activeTabLabel = this.navTabs.find(tab => tab.article === data.article)?.navLabel;
    }));

    this.subscriptions.add(this.route.fragment.subscribe(fragment => { this.fragment = fragment; }));
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

}
